(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paris-arabic-product"]) return;
  try {
    
if (!customElements.get('paris-product')) {
  class ParisProduct extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.form = this.querySelector('form');
      this.variant = this.querySelector('[data-variant]');
      this.busy = this.busy || false;
      this.checkoutReady = this.checkoutReady || false;
      this.bundles = this.querySelector('[data-bundles]');
      this.packIndex = Number(this.dataset.bundleIndex);
      this.pack = this.pack || 1;
      this.querySelectorAll('[data-pack-choice]').forEach(input => {
        input.checked = Number(input.value) === this.pack;
        input.addEventListener('change', () => {
          this.pack = Number(input.value);
          if (this.packIndex >= 0) {
            const match = this.findPack(this.pack);
            if (match) this.variant.value = match.value;
          }
          this.updateVariant();
        }, {signal});
      });
      window.addEventListener('pageshow', () => {
        this.busy = false;
        this.checkoutReady = false;
        this.variant.disabled = false;
        this.updateVariant(false);
      }, {signal});
      this.form.addEventListener('submit', event => this.add(event), {signal});
      this.querySelectorAll('[data-submit]').forEach(button => {
        button.addEventListener('click', event => this.add(event), {signal, capture:true});
      });
      this.form.elements.quantity.addEventListener('input', () => this.setButtons(), {signal});
      this.variant.addEventListener('change', () => this.updateVariant(), {signal});
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-thumbnail]');
        if (thumb) this.showMedia(thumb.dataset.thumbnail);
        const arrow = event.target.closest('[data-gallery-step]');
        if (arrow) {
          const panels = [...this.querySelectorAll('[data-media]')];
          const index = panels.findIndex(panel => !panel.hidden);
          const next = (index + Number(arrow.dataset.galleryStep) + panels.length) % panels.length;
          if (panels[next]) this.showMedia(panels[next].dataset.media);
        }
        const opener = event.target.closest('[data-open-video]');
        if (opener) {
          const dialog = document.getElementById(opener.dataset.openVideo);
          if (dialog) {
            this.querySelectorAll('video').forEach(video => video.pause());
            dialog.showModal();
            dialog.querySelector('video')?.play().catch(() => {});
          }
        }
        const closer = event.target.closest('[data-close-video]');
        if (closer) closer.closest('dialog').close();
      }, {signal});
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('close', () => dialog.querySelector('video')?.pause(), {signal});
        dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); }, {signal});
      });
      this.updateVariant(false);
      const sticky = this.querySelector('[data-sticky]');
      if (sticky && typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(() => { this.style.paddingBottom = `${sticky.getBoundingClientRect().height + 24}px`; });
        this.resizeObserver.observe(sticky);
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.querySelectorAll('video').forEach(video => video.pause());
    }
    showMedia(id) {
      const target = this.querySelector(`[data-media="${id}"]`);
      if (!target) return;
      this.querySelectorAll('[data-media]').forEach(panel => {
        panel.hidden = panel !== target;
        if (panel.hidden) panel.querySelectorAll('video').forEach(video => video.pause());
      });
      this.querySelectorAll('[data-thumbnail]').forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb.dataset.thumbnail === String(id))));
    }
    findPack(pack) {
      const current = this.variant.selectedOptions[0];
      if (!current) return null;
      const selected = JSON.parse(current.dataset.options || '[]');
      return [...this.variant.options].find(option => {
        if (option.dataset.pack !== String(pack)) return false;
        const values = JSON.parse(option.dataset.options || '[]');
        return values.every((value, index) => index === this.packIndex || value === selected[index]);
      });
    }
    canBuy(option, quantity) {
      if (!option || option.dataset.available !== 'true') return false;
      const minimum = Number(option.dataset.min || 1);
      const step = Number(option.dataset.step || 1);
      const maximum = option.dataset.max === '' ? Infinity : Number(option.dataset.max);
      const stock = option.dataset.stock === '' ? Infinity : Number(option.dataset.stock);
      return quantity >= minimum && (quantity - minimum) % step === 0 && quantity <= maximum && quantity <= stock;
    }
    bundleDeal(pack, current) {
      const single = this.packIndex >= 0 ? this.findPack(1) : current;
      const candidate = this.packIndex >= 0 ? this.findPack(pack) : current;
      if (!candidate) return {price:'—', compare:'', savings:0, percent:0};
      const multiplier = this.packIndex >= 0 ? 1 : pack;
      const priceCents = Number(candidate.dataset.priceCents) * multiplier;
      const baseline = single ? Number(single.dataset.priceCents) * pack : 0;
      const savings = pack > 1 && baseline > priceCents ? baseline - priceCents : 0;
      const compareCents = Number(candidate.dataset.compareCents || 0) * multiplier;
      let compare = compareCents > priceCents ? (multiplier === 1 ? candidate.dataset.compare : candidate.dataset['compare' + multiplier]) : '';
      if (!compare && savings > 0) compare = single.dataset['total' + pack];
      return {
        price: multiplier === 1 ? candidate.dataset.price : candidate.dataset['total' + multiplier],
        compare: compare || '',
        savings,
        percent: savings > 0 ? Math.round(savings * 1000 / baseline) / 10 : 0
      };
    }
    savingText(deal) {
      if (deal.savings <= 0) return this.dataset.noSaveLabel;
      let amount;
      try { amount = new Intl.NumberFormat('en-AE', {style:'currency', currency:this.dataset.currency || 'AED', currencyDisplay:'code'}).format(deal.savings / 100); }
      catch { amount = (deal.savings / 100).toFixed(2) + ' ' + (this.dataset.currency || 'AED'); }
      return this.dataset.saveLabel + ' ' + deal.percent + '% · ' + amount;
    }
    updateVariant(updateUrl = true) {
      const option = this.variant.selectedOptions[0];
      if (!option) return;
      if (this.packIndex >= 0) this.pack = Number(option.dataset.pack) || 1;
      const qty = this.form.elements.quantity;
      qty.min = option.dataset.min || '1';
      qty.step = option.dataset.step || '1';
      if (option.dataset.max) qty.max = option.dataset.max; else qty.removeAttribute('max');
      if (this.bundles) {
        this.bundles.hidden = false;
        this.querySelector('[data-quantity-wrap]').hidden = true;
        qty.value = this.packIndex >= 0 ? '1' : String(this.pack);
        this.querySelectorAll('[data-pack-choice]').forEach(input => {
          const pack = Number(input.value);
          const candidate = this.packIndex >= 0 ? this.findPack(pack) : option;
          const quantity = this.packIndex >= 0 ? 1 : pack;
          const available = this.canBuy(candidate, quantity);
          input.disabled = this.busy || !available;
          input.checked = pack === this.pack;
          input.toggleAttribute('checked', input.checked);
          const card = input.closest('label');
          const deal = this.bundleDeal(pack, option);
          card.querySelector('[data-pack-price]').textContent = deal.price;
          const comparePrice = card.querySelector('[data-pack-compare]');
          comparePrice.textContent = deal.compare;
          comparePrice.hidden = !deal.compare;
          const saving = card.querySelector('[data-pack-savings]');
          if (saving) { saving.textContent = candidate ? this.savingText(deal) : ''; saving.hidden = !candidate; }
          const badge = card.querySelector('[data-pack-badge]');
          if (badge) badge.hidden = !available || deal.savings <= 0;
          card.querySelector('[data-pack-status]').hidden = available;
        });
      } else {
        if (!qty.value || Number(qty.value) < Number(qty.min)) qty.value = qty.min;
        if (qty.max && Number(qty.value) > Number(qty.max)) qty.value = qty.max;
      }
      const selectedSaving = this.querySelector('[data-selected-savings]');
      if (selectedSaving) {
        const deal = this.bundleDeal(this.pack, option);
        selectedSaving.textContent = this.savingText(deal);
        selectedSaving.hidden = this.pack === 1 || deal.savings <= 0;
      }
      qty.setAttribute('value', qty.value);
      const multiplier = this.bundles && this.packIndex < 0 ? this.pack : 1;
      this.querySelectorAll('[data-price]:not(option)').forEach(node => { node.textContent = option.dataset['total' + multiplier] || option.dataset.price; });
      const compare = this.querySelector('[data-compare]:not(option)');
      compare.textContent = multiplier === 1 ? option.dataset.compare || '' : option.dataset['compare' + multiplier] || '';
      compare.hidden = !compare.textContent;
      this.setButtons();
      if (option.dataset.media) this.showMedia(option.dataset.media);
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      }
    }
    setButtons() {
      const available = this.canBuy(this.variant.selectedOptions[0], Number(this.form.elements.quantity.value));
      this.querySelectorAll('[data-submit]').forEach(button => {
        button.disabled = this.busy || !available;
        button.setAttribute('aria-busy', String(this.busy));
        button.querySelector('[data-button-label]').textContent = this.busy ? this.dataset.addingLabel : available ? this.dataset.addLabel : this.dataset.soldLabel;
      });
    }
    async add(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.busy) return;
      if (this.checkoutReady) { window.location.assign(this.dataset.checkoutUrl); return; }
      if (!this.canBuy(this.variant.selectedOptions[0], Number(this.form.elements.quantity.value)) || !this.form.reportValidity()) return;
      const error = this.querySelector('[data-error]');
      const success = this.querySelector('[data-success]');
      const stickyMessage = this.querySelector('[data-sticky-message]');
      error.hidden = true;
      success.hidden = true;
      if (stickyMessage) stickyMessage.hidden = true;
      const formData = new FormData(this.form);
      formData.delete('return_to');
      formData.delete('paris_bundle');
      formData.set('id', this.variant.value);
      formData.set('quantity', this.bundles ? String(this.packIndex >= 0 ? 1 : this.pack) : this.form.elements.quantity.value);
      this.busy = true;
      this.setButtons();
      this.variant.disabled = true;
      this.querySelectorAll('[data-pack-choice]').forEach(input => { input.disabled = true; });
      try {
        const response = await fetch(this.dataset.addUrl + '.js', {method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:formData});
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || this.dataset.errorLabel);
        this.checkoutReady = true;
        success.hidden = false;
        if (stickyMessage) {stickyMessage.textContent = success.textContent;stickyMessage.hidden = false;}
        window.location.assign(this.dataset.checkoutUrl);
      } catch (failure) {
        error.textContent = failure.message || this.dataset.errorLabel;
        error.hidden = false;
        if (stickyMessage) {stickyMessage.textContent = error.textContent;stickyMessage.hidden = false;}
        this.busy = false;
        this.variant.disabled = false;
        this.updateVariant(false);
      }
    }
  }
  customElements.define('paris-product', ParisProduct);
}

  } catch(e) { console.error(e); }
})();
})();
